
import { useState, useEffect } from 'react';

const MobileAnimatedBackground = () => {
  const [towers, setTowers] = useState<Array<{ id: number; x: number; y: number; delay: number; height: number }>>([]);

  useEffect(() => {
    const generateTowers = () => {
      const newTowers = [];
      for (let i = 0; i < 8; i++) {
        newTowers.push({
          id: i,
          x: Math.random() * 100,
          y: Math.random() * 100,
          delay: Math.random() * 3,
          height: 40 + Math.random() * 60
        });
      }
      setTowers(newTowers);
    };

    generateTowers();
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Animated Grid */}
      <div className="absolute inset-0 opacity-10">
        <div className="w-full h-full bg-gradient-to-br from-pink-100 to-purple-100"></div>
        <div 
          className="absolute inset-0 animate-float"
          style={{
            backgroundImage: `
              linear-gradient(rgba(236, 72, 153, 0.1) 1px, transparent 1px),
              linear-gradient(90deg, rgba(236, 72, 153, 0.1) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px'
          }}
        />
      </div>

      {/* Cell Towers */}
      {towers.map((tower) => (
        <div
          key={tower.id}
          className="absolute animate-pulse"
          style={{
            left: `${tower.x}%`,
            top: `${tower.y}%`,
            animationDelay: `${tower.delay}s`
          }}
        >
          {/* Tower Base */}
          <div 
            className="bg-pink-200 opacity-30"
            style={{
              width: '3px',
              height: `${tower.height}px`,
              transform: 'rotate(-10deg)'
            }}
          />
          
          {/* Signal Waves */}
          <div className="absolute -top-2 -left-4">
            {[1, 2, 3].map((wave) => (
              <div
                key={wave}
                className="absolute rounded-full border border-pink-300 opacity-20 animate-ping"
                style={{
                  width: `${wave * 16}px`,
                  height: `${wave * 16}px`,
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%, -50%)',
                  animationDelay: `${tower.delay + wave * 0.5}s`,
                  animationDuration: `${2 + wave}s`
                }}
              />
            ))}
          </div>
        </div>
      ))}

      {/* Floating Particles */}
      {[...Array(15)].map((_, i) => (
        <div
          key={i}
          className="absolute w-1 h-1 bg-pink-400 rounded-full opacity-30 animate-bounce"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 3}s`,
            animationDuration: `${3 + Math.random() * 4}s`
          }}
        />
      ))}
    </div>
  );
};

export default MobileAnimatedBackground;
